// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  .storelocatorlink__container {
    display: flex;
    align-items: flex-end;

    &--fav {
      display: flex;
      align-items: center;
    }
  }
  .storelocatorlink__img {
    margin-right: 5px;
  }

  .storelocator--image {
    width: 25px;
    height: 25px;
  }
  .storelocatorlink__detail {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs10};
    }
    .storelocatorlink__detail__storename {
      text-transform: capitalize;
      &:hover {
        color: ${(props) => props.theme.colorPalette.blue[500]};
      }
    }
    .store-welcome-txt {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
      font-weight: ${(props) => props.theme.typography.fontWeights.semibold};
      @media ${(props) => props.theme.mediaQuery.medium} {
        display: none;
      }
    }
  }
`;
export const StoreLocatorDetails = css`
  div.modal-inner-content-wrapper {
    width: 375px;
    height: 130px;
    top: ${(props) =>
      props.headerMiddleNavHeight !== 0 ? `${props.headerMiddleNavHeight}px` : '180px'};
    transform: translate(-50%, 0);
    right: calc(100vw / 2 - 720px - 150px);
    left: unset;
    flex-grow: 0;
    background-color: #fff;
    border: 1px solid #eee;
    ${(props) => props.fromCondensedHeader && `top:74px;`};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 100%;
      top: ${(props) =>
        props.headerMiddleNavHeight !== 0 ? `${props.headerMiddleNavHeight}px` : '242px'};
      left: 50%;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      ${(props) => props.fromCondensedHeader && `top:66px !important;`};
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      top: ${(props) =>
        props.headerMiddleNavHeight !== 0 ? `${props.headerMiddleNavHeight}px` : '222px'};
      left: calc(100vw - 240px);
    }
    @media ${(props) => props.theme.mediaQuery.largeOnly} {
      left: calc(100vw - 240px);
    }
    .Modal-Header {
      display: none;
    }
    /* stylelint-disable max-nesting-depth */
    /* stylelint-disable no-descending-specificity*/
    .selected-store-wraper {
      background-color: #edf5fb;
      padding: 10px 16px 10px 25px;
      .selected-store-lbl {
        display: block;
        text-align: left;
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 6px;
        margin-left: 6px;
        text-transform: uppercase;
      }
      &.no-store {
        padding: 22px 16px 14px 24px;
      }
      .content {
        display: flex;
        .select-store-lbl {
          font-weight: ${(props) => props.theme.typography.fontWeights.semibold};
          margin-left: 5px;
          margin-top: 5px;
        }
        .storelocatorlink__img {
          margin-right: 5px;
        }

        .storelocator--image {
          width: 25px;
          height: 25px;
        }
        .storelocatorlink__detail {
          @media ${(props) => props.theme.mediaQuery.smallOnly} {
            font-size: ${(props) => props.theme.typography.fontSizes.fs10};
          }
          .storelocatorlink__detail__storename {
            text-transform: capitalize;
            font-size: 14px;
            font-weight: 800;

            &:hover {
              color: #005d95;
            }
          }
          .store-welcome-txt {
            font-size: ${(props) => props.theme.typography.fontSizes.fs12};
            font-weight: ${(props) => props.theme.typography.fontWeights.semibold};
            @media ${(props) => props.theme.mediaQuery.medium} {
              display: none;
            }
          }
        }
      }
    }
    .change-store-wrapper {
      padding: 12px 16px 14px 25px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .hidden {
        display: none;
      }
      .store-locator-svg {
        float: left;
        height: 25px;
        width: auto;
      }
      .shop-this-store {
        font-weight: 800;
        text-decoration: underline;
        margin-left: 8px;
        cursor: pointer;
      }
      .select-different-store {
        color: #005d95;
        font-weight: 800;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
`;
